import { useGetIncomingPostbackQuery } from "api/TenantSlug/IncomingPostback/hooks.ts";
import { TrackingToolFromEditorForm } from "components/Forms/TrackingToolFromEditorForm/TrackingToolFromEditorForm.tsx";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { usePermission } from "hooks/usePermissions.ts";
import { PermissionEnum } from "types/enums.ts";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getTrackingToolFromItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor-old/"
)({
    component: TrackingToolFromEditorOldPage,
    staticData: {
        permissions: [PermissionEnum.ToolTrackingIncomingEditEditor],
        showInSideMenu: false,
        label: "pages.tool.tracking.from.editor-old.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.tracking.from.editor-old.title"),
        };
    },
});

function TrackingToolFromEditorOldPage() {
    const { id } = Route.useParams();
    const { data, isLoading, isError } = useGetIncomingPostbackQuery(id, {});
    const incomingPostback = data?.incomingPostback;
    const permissionUtils = usePermission();
    const formId = FormId.TrackingToolFromEditorForm;

    if (!incomingPostback) {
        return (
            <QueryState
                isLoading={isLoading}
                isError={isError || !isLoading}
                errorKey="errors.loading_incoming_postback"
            />
        );
    }

    return (
        <TenantPage
            headerNavigationItems={getTrackingToolFromItems}
            isEdit
            saveFormId={permissionUtils.hasPermission(PermissionEnum.ToolTrackingIncomingEditEditor) ? formId : null}
        >
            <SectionContentWrapper withBackground>
                <TrackingToolFromEditorForm key={id} postback={incomingPostback} />
            </SectionContentWrapper>
        </TenantPage>
    );
}
